/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssignImagesDto,
  ConfirmDonationDto,
  CreateDonationDto,
  CreateDreamDto,
  DreamControllerAddFavorite200,
  DreamControllerAddFavorite429,
  DreamControllerApprove401,
  DreamControllerApprove429,
  DreamControllerAssignImages401,
  DreamControllerAssignImages429,
  DreamControllerConfirmClose429,
  DreamControllerConfirmCloseBody,
  DreamControllerConfirmDonation429,
  DreamControllerCreate429,
  DreamControllerDonate429,
  DreamControllerFindAll200,
  DreamControllerFindAll429,
  DreamControllerFindAllParams,
  DreamControllerFindOne429,
  DreamControllerGetMy429,
  DreamControllerInitiateClose200,
  DreamControllerInitiateClose429,
  DreamControllerInitiateDonation429,
  DreamControllerListDonations200,
  DreamControllerListDonations401,
  DreamControllerListDonations429,
  DreamControllerListDonationsParams,
  DreamControllerListTransactions200,
  DreamControllerListTransactions401,
  DreamControllerListTransactions429,
  DreamControllerListTransactionsParams,
  DreamControllerReject401,
  DreamControllerReject429,
  DreamControllerRemove200,
  DreamControllerRemove429,
  DreamControllerRemoveFavorite200,
  DreamControllerRemoveFavorite429,
  DreamControllerUpdate429,
  DreamDto,
  InitiateDonationDto,
  InitiateDonationResponseDto,
  MyDreamDto,
  RejectDreamDto,
  UpdateDreamDto
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Creates a new fundraising dream with title, description, and target amount. Optionally assigns tags. Requires authentication.
 * @summary Create a new dream
 */
export const dreamControllerCreate = (
    createDreamDto: CreateDreamDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamDto>(
      {url: `/dreams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDreamDto, signal
    },
      options);
    }
  


export const getDreamControllerCreateMutationOptions = <TError = null | null | DreamControllerCreate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerCreate>>, TError,{data: CreateDreamDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerCreate>>, TError,{data: CreateDreamDto}, TContext> => {

const mutationKey = ['dreamControllerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerCreate>>, {data: CreateDreamDto}> = (props) => {
          const {data} = props ?? {};

          return  dreamControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerCreate>>>
    export type DreamControllerCreateMutationBody = CreateDreamDto
    export type DreamControllerCreateMutationError = null | null | DreamControllerCreate429

    /**
 * @summary Create a new dream
 */
export const useDreamControllerCreate = <TError = null | null | DreamControllerCreate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerCreate>>, TError,{data: CreateDreamDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerCreate>>,
        TError,
        {data: CreateDreamDto},
        TContext
      > => {

      const mutationOptions = getDreamControllerCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Retrieves a paginated list of dreams. Supports cursor pagination, sorting, and filtering favorites.
 * @summary Get list of dreams
 */
export const dreamControllerFindAll = (
    params?: DreamControllerFindAllParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamControllerFindAll200>(
      {url: `/dreams`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getDreamControllerFindAllQueryKey = (params?: DreamControllerFindAllParams,) => {
    return [`/dreams`, ...(params ? [params]: [])] as const;
    }

    
export const getDreamControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof dreamControllerFindAll>>, TError = null | null | DreamControllerFindAll429>(params?: DreamControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDreamControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dreamControllerFindAll>>> = ({ signal }) => dreamControllerFindAll(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DreamControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof dreamControllerFindAll>>>
export type DreamControllerFindAllQueryError = null | null | DreamControllerFindAll429


export function useDreamControllerFindAll<TData = Awaited<ReturnType<typeof dreamControllerFindAll>>, TError = null | null | DreamControllerFindAll429>(
 params: undefined |  DreamControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerFindAll<TData = Awaited<ReturnType<typeof dreamControllerFindAll>>, TError = null | null | DreamControllerFindAll429>(
 params?: DreamControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerFindAll<TData = Awaited<ReturnType<typeof dreamControllerFindAll>>, TError = null | null | DreamControllerFindAll429>(
 params?: DreamControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get list of dreams
 */

export function useDreamControllerFindAll<TData = Awaited<ReturnType<typeof dreamControllerFindAll>>, TError = null | null | DreamControllerFindAll429>(
 params?: DreamControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDreamControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Approve dream moderation
 */
export const dreamControllerApprove = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamDto | DreamDto>(
      {url: `/dreams/${id}/moderation/approve`, method: 'POST', signal
    },
      options);
    }
  


export const getDreamControllerApproveMutationOptions = <TError = DreamControllerApprove401 | null | DreamControllerApprove429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerApprove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerApprove>>, TError,{id: string}, TContext> => {

const mutationKey = ['dreamControllerApprove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerApprove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dreamControllerApprove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerApproveMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerApprove>>>
    
    export type DreamControllerApproveMutationError = DreamControllerApprove401 | null | DreamControllerApprove429

    /**
 * @summary Approve dream moderation
 */
export const useDreamControllerApprove = <TError = DreamControllerApprove401 | null | DreamControllerApprove429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerApprove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerApprove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDreamControllerApproveMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Reject dream moderation
 */
export const dreamControllerReject = (
    id: string,
    rejectDreamDto: RejectDreamDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamDto | DreamDto>(
      {url: `/dreams/${id}/moderation/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectDreamDto, signal
    },
      options);
    }
  


export const getDreamControllerRejectMutationOptions = <TError = DreamControllerReject401 | null | DreamControllerReject429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerReject>>, TError,{id: string;data: RejectDreamDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerReject>>, TError,{id: string;data: RejectDreamDto}, TContext> => {

const mutationKey = ['dreamControllerReject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerReject>>, {id: string;data: RejectDreamDto}> = (props) => {
          const {id,data} = props ?? {};

          return  dreamControllerReject(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerRejectMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerReject>>>
    export type DreamControllerRejectMutationBody = RejectDreamDto
    export type DreamControllerRejectMutationError = DreamControllerReject401 | null | DreamControllerReject429

    /**
 * @summary Reject dream moderation
 */
export const useDreamControllerReject = <TError = DreamControllerReject401 | null | DreamControllerReject429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerReject>>, TError,{id: string;data: RejectDreamDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerReject>>,
        TError,
        {id: string;data: RejectDreamDto},
        TContext
      > => {

      const mutationOptions = getDreamControllerRejectMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns your most recently updated dream and recent history. If none exists, returns 404.
 * @summary Get my latest dream
 */
export const dreamControllerGetMy = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<MyDreamDto>(
      {url: `/dreams/my`, method: 'GET', signal
    },
      options);
    }
  

export const getDreamControllerGetMyQueryKey = () => {
    return [`/dreams/my`] as const;
    }

    
export const getDreamControllerGetMyQueryOptions = <TData = Awaited<ReturnType<typeof dreamControllerGetMy>>, TError = null | null | DreamControllerGetMy429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerGetMy>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDreamControllerGetMyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dreamControllerGetMy>>> = ({ signal }) => dreamControllerGetMy(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dreamControllerGetMy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DreamControllerGetMyQueryResult = NonNullable<Awaited<ReturnType<typeof dreamControllerGetMy>>>
export type DreamControllerGetMyQueryError = null | null | DreamControllerGetMy429


export function useDreamControllerGetMy<TData = Awaited<ReturnType<typeof dreamControllerGetMy>>, TError = null | null | DreamControllerGetMy429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerGetMy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerGetMy>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerGetMy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerGetMy<TData = Awaited<ReturnType<typeof dreamControllerGetMy>>, TError = null | null | DreamControllerGetMy429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerGetMy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerGetMy>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerGetMy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerGetMy<TData = Awaited<ReturnType<typeof dreamControllerGetMy>>, TError = null | null | DreamControllerGetMy429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerGetMy>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get my latest dream
 */

export function useDreamControllerGetMy<TData = Awaited<ReturnType<typeof dreamControllerGetMy>>, TError = null | null | DreamControllerGetMy429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerGetMy>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDreamControllerGetMyQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Fetches a dream by its unique ID. Returns 404 if not found. If the requester is the owner and the dream is currently frozen, the response additionally includes unfreezeProgress (requiredAmount, contributedAmount, remainingAmount).
 * @summary Get dream by ID
 */
export const dreamControllerFindOne = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamDto>(
      {url: `/dreams/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getDreamControllerFindOneQueryKey = (id?: string,) => {
    return [`/dreams/${id}`] as const;
    }

    
export const getDreamControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof dreamControllerFindOne>>, TError = null | null | DreamControllerFindOne429>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDreamControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dreamControllerFindOne>>> = ({ signal }) => dreamControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DreamControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof dreamControllerFindOne>>>
export type DreamControllerFindOneQueryError = null | null | DreamControllerFindOne429


export function useDreamControllerFindOne<TData = Awaited<ReturnType<typeof dreamControllerFindOne>>, TError = null | null | DreamControllerFindOne429>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerFindOne<TData = Awaited<ReturnType<typeof dreamControllerFindOne>>, TError = null | null | DreamControllerFindOne429>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerFindOne<TData = Awaited<ReturnType<typeof dreamControllerFindOne>>, TError = null | null | DreamControllerFindOne429>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get dream by ID
 */

export function useDreamControllerFindOne<TData = Awaited<ReturnType<typeof dreamControllerFindOne>>, TError = null | null | DreamControllerFindOne429>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDreamControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Updates the title or description of an existing dream. Only the owner can perform this action.
 * @summary Update a dream
 */
export const dreamControllerUpdate = (
    id: string,
    updateDreamDto: UpdateDreamDto,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DreamDto>(
      {url: `/dreams/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateDreamDto
    },
      options);
    }
  


export const getDreamControllerUpdateMutationOptions = <TError = null | null | null | null | DreamControllerUpdate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerUpdate>>, TError,{id: string;data: UpdateDreamDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerUpdate>>, TError,{id: string;data: UpdateDreamDto}, TContext> => {

const mutationKey = ['dreamControllerUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerUpdate>>, {id: string;data: UpdateDreamDto}> = (props) => {
          const {id,data} = props ?? {};

          return  dreamControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerUpdate>>>
    export type DreamControllerUpdateMutationBody = UpdateDreamDto
    export type DreamControllerUpdateMutationError = null | null | null | null | DreamControllerUpdate429

    /**
 * @summary Update a dream
 */
export const useDreamControllerUpdate = <TError = null | null | null | null | DreamControllerUpdate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerUpdate>>, TError,{id: string;data: UpdateDreamDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerUpdate>>,
        TError,
        {id: string;data: UpdateDreamDto},
        TContext
      > => {

      const mutationOptions = getDreamControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Deletes the specified dream. Only the owner can delete it. Requires delete_own_dreams permission.
 * @summary Delete a dream
 */
export const dreamControllerRemove = (
    id: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DreamControllerRemove200>(
      {url: `/dreams/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDreamControllerRemoveMutationOptions = <TError = null | null | null | DreamControllerRemove429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['dreamControllerRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dreamControllerRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerRemove>>>
    
    export type DreamControllerRemoveMutationError = null | null | null | DreamControllerRemove429

    /**
 * @summary Delete a dream
 */
export const useDreamControllerRemove = <TError = null | null | null | DreamControllerRemove429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDreamControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns paginated list of confirmed donations (user, amount, message) ordered by time desc.
 * @summary List donations for a dream
 */
export const dreamControllerListDonations = (
    id: string,
    params?: DreamControllerListDonationsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamControllerListDonations200>(
      {url: `/dreams/${id}/donations`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getDreamControllerListDonationsQueryKey = (id?: string,
    params?: DreamControllerListDonationsParams,) => {
    return [`/dreams/${id}/donations`, ...(params ? [params]: [])] as const;
    }

    
export const getDreamControllerListDonationsQueryOptions = <TData = Awaited<ReturnType<typeof dreamControllerListDonations>>, TError = DreamControllerListDonations401 | DreamControllerListDonations429>(id: string,
    params?: DreamControllerListDonationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListDonations>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDreamControllerListDonationsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dreamControllerListDonations>>> = ({ signal }) => dreamControllerListDonations(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListDonations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DreamControllerListDonationsQueryResult = NonNullable<Awaited<ReturnType<typeof dreamControllerListDonations>>>
export type DreamControllerListDonationsQueryError = DreamControllerListDonations401 | DreamControllerListDonations429


export function useDreamControllerListDonations<TData = Awaited<ReturnType<typeof dreamControllerListDonations>>, TError = DreamControllerListDonations401 | DreamControllerListDonations429>(
 id: string,
    params: undefined |  DreamControllerListDonationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListDonations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerListDonations>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerListDonations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerListDonations<TData = Awaited<ReturnType<typeof dreamControllerListDonations>>, TError = DreamControllerListDonations401 | DreamControllerListDonations429>(
 id: string,
    params?: DreamControllerListDonationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListDonations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerListDonations>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerListDonations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerListDonations<TData = Awaited<ReturnType<typeof dreamControllerListDonations>>, TError = DreamControllerListDonations401 | DreamControllerListDonations429>(
 id: string,
    params?: DreamControllerListDonationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListDonations>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List donations for a dream
 */

export function useDreamControllerListDonations<TData = Awaited<ReturnType<typeof dreamControllerListDonations>>, TError = DreamControllerListDonations401 | DreamControllerListDonations429>(
 id: string,
    params?: DreamControllerListDonationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListDonations>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDreamControllerListDonationsQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Contributes a monetary donation to the specified dream. Amount must be positive. Requires authentication.
 * @summary Donate to a dream
 */
export const dreamControllerDonate = (
    id: string,
    createDonationDto: CreateDonationDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamDto | DreamDto>(
      {url: `/dreams/${id}/donations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDonationDto, signal
    },
      options);
    }
  


export const getDreamControllerDonateMutationOptions = <TError = null | null | null | DreamControllerDonate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerDonate>>, TError,{id: string;data: CreateDonationDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerDonate>>, TError,{id: string;data: CreateDonationDto}, TContext> => {

const mutationKey = ['dreamControllerDonate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerDonate>>, {id: string;data: CreateDonationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  dreamControllerDonate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerDonateMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerDonate>>>
    export type DreamControllerDonateMutationBody = CreateDonationDto
    export type DreamControllerDonateMutationError = null | null | null | DreamControllerDonate429

    /**
 * @summary Donate to a dream
 */
export const useDreamControllerDonate = <TError = null | null | null | DreamControllerDonate429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerDonate>>, TError,{id: string;data: CreateDonationDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerDonate>>,
        TError,
        {id: string;data: CreateDonationDto},
        TContext
      > => {

      const mutationOptions = getDreamControllerDonateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Prepares a donation transaction (status initiated) and returns payload for client wallet. Requires authentication.
 * @summary Initiate a donation transaction
 */
export const dreamControllerInitiateDonation = (
    id: string,
    initiateDonationDto: InitiateDonationDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<InitiateDonationResponseDto | InitiateDonationResponseDto>(
      {url: `/dreams/${id}/donations/init`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initiateDonationDto, signal
    },
      options);
    }
  


export const getDreamControllerInitiateDonationMutationOptions = <TError = null | null | null | null | DreamControllerInitiateDonation429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerInitiateDonation>>, TError,{id: string;data: InitiateDonationDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerInitiateDonation>>, TError,{id: string;data: InitiateDonationDto}, TContext> => {

const mutationKey = ['dreamControllerInitiateDonation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerInitiateDonation>>, {id: string;data: InitiateDonationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  dreamControllerInitiateDonation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerInitiateDonationMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerInitiateDonation>>>
    export type DreamControllerInitiateDonationMutationBody = InitiateDonationDto
    export type DreamControllerInitiateDonationMutationError = null | null | null | null | DreamControllerInitiateDonation429

    /**
 * @summary Initiate a donation transaction
 */
export const useDreamControllerInitiateDonation = <TError = null | null | null | null | DreamControllerInitiateDonation429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerInitiateDonation>>, TError,{id: string;data: InitiateDonationDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerInitiateDonation>>,
        TError,
        {id: string;data: InitiateDonationDto},
        TContext
      > => {

      const mutationOptions = getDreamControllerInitiateDonationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Verifies an on-chain signed donation and records it to the dream.
 * @summary Confirm a donation transaction
 */
export const dreamControllerConfirmDonation = (
    id: string,
    confirmDonationDto: ConfirmDonationDto,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamDto | DreamDto>(
      {url: `/dreams/${id}/donations/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmDonationDto, signal
    },
      options);
    }
  


export const getDreamControllerConfirmDonationMutationOptions = <TError = null | null | null | null | DreamControllerConfirmDonation429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerConfirmDonation>>, TError,{id: string;data: ConfirmDonationDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerConfirmDonation>>, TError,{id: string;data: ConfirmDonationDto}, TContext> => {

const mutationKey = ['dreamControllerConfirmDonation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerConfirmDonation>>, {id: string;data: ConfirmDonationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  dreamControllerConfirmDonation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerConfirmDonationMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerConfirmDonation>>>
    export type DreamControllerConfirmDonationMutationBody = ConfirmDonationDto
    export type DreamControllerConfirmDonationMutationError = null | null | null | null | DreamControllerConfirmDonation429

    /**
 * @summary Confirm a donation transaction
 */
export const useDreamControllerConfirmDonation = <TError = null | null | null | null | DreamControllerConfirmDonation429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerConfirmDonation>>, TError,{id: string;data: ConfirmDonationDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerConfirmDonation>>,
        TError,
        {id: string;data: ConfirmDonationDto},
        TContext
      > => {

      const mutationOptions = getDreamControllerConfirmDonationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Adds the specified dream to the current user's favorites list.
 * @summary Add dream to favorites
 */
export const dreamControllerAddFavorite = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamControllerAddFavorite200 | null>(
      {url: `/dreams/${id}/favorite`, method: 'POST', signal
    },
      options);
    }
  


export const getDreamControllerAddFavoriteMutationOptions = <TError = null | null | null | DreamControllerAddFavorite429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerAddFavorite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerAddFavorite>>, TError,{id: string}, TContext> => {

const mutationKey = ['dreamControllerAddFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerAddFavorite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dreamControllerAddFavorite(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerAddFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerAddFavorite>>>
    
    export type DreamControllerAddFavoriteMutationError = null | null | null | DreamControllerAddFavorite429

    /**
 * @summary Add dream to favorites
 */
export const useDreamControllerAddFavorite = <TError = null | null | null | DreamControllerAddFavorite429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerAddFavorite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerAddFavorite>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDreamControllerAddFavoriteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Removes the specified dream from the current user's favorites list.
 * @summary Remove dream from favorites
 */
export const dreamControllerRemoveFavorite = (
    id: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DreamControllerRemoveFavorite200>(
      {url: `/dreams/${id}/favorite`, method: 'DELETE'
    },
      options);
    }
  


export const getDreamControllerRemoveFavoriteMutationOptions = <TError = null | null | null | DreamControllerRemoveFavorite429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerRemoveFavorite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerRemoveFavorite>>, TError,{id: string}, TContext> => {

const mutationKey = ['dreamControllerRemoveFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerRemoveFavorite>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dreamControllerRemoveFavorite(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerRemoveFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerRemoveFavorite>>>
    
    export type DreamControllerRemoveFavoriteMutationError = null | null | null | DreamControllerRemoveFavorite429

    /**
 * @summary Remove dream from favorites
 */
export const useDreamControllerRemoveFavorite = <TError = null | null | null | DreamControllerRemoveFavorite429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerRemoveFavorite>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerRemoveFavorite>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDreamControllerRemoveFavoriteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Initiates dream closure. Only owner can close their dream. Requires update_own_dreams permission.
 * @summary Initiate manual close session for a dream
 */
export const dreamControllerInitiateClose = (
    id: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamControllerInitiateClose200 | null>(
      {url: `/dreams/${id}/close/init`, method: 'POST', signal
    },
      options);
    }
  


export const getDreamControllerInitiateCloseMutationOptions = <TError = null | null | DreamControllerInitiateClose429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerInitiateClose>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerInitiateClose>>, TError,{id: string}, TContext> => {

const mutationKey = ['dreamControllerInitiateClose'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerInitiateClose>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  dreamControllerInitiateClose(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerInitiateCloseMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerInitiateClose>>>
    
    export type DreamControllerInitiateCloseMutationError = null | null | DreamControllerInitiateClose429

    /**
 * @summary Initiate manual close session for a dream
 */
export const useDreamControllerInitiateClose = <TError = null | null | DreamControllerInitiateClose429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerInitiateClose>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerInitiateClose>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDreamControllerInitiateCloseMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Confirms and completes dream closure. Only owner can close their dream. Requires update_own_dreams permission.
 * @summary Confirm manual close session and close dream
 */
export const dreamControllerConfirmClose = (
    id: string,
    dreamControllerConfirmCloseBody: DreamControllerConfirmCloseBody,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<null>(
      {url: `/dreams/${id}/close/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dreamControllerConfirmCloseBody, signal
    },
      options);
    }
  


export const getDreamControllerConfirmCloseMutationOptions = <TError = null | null | DreamControllerConfirmClose429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerConfirmClose>>, TError,{id: string;data: DreamControllerConfirmCloseBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerConfirmClose>>, TError,{id: string;data: DreamControllerConfirmCloseBody}, TContext> => {

const mutationKey = ['dreamControllerConfirmClose'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerConfirmClose>>, {id: string;data: DreamControllerConfirmCloseBody}> = (props) => {
          const {id,data} = props ?? {};

          return  dreamControllerConfirmClose(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerConfirmCloseMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerConfirmClose>>>
    export type DreamControllerConfirmCloseMutationBody = DreamControllerConfirmCloseBody
    export type DreamControllerConfirmCloseMutationError = null | null | DreamControllerConfirmClose429

    /**
 * @summary Confirm manual close session and close dream
 */
export const useDreamControllerConfirmClose = <TError = null | null | DreamControllerConfirmClose429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerConfirmClose>>, TError,{id: string;data: DreamControllerConfirmCloseBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerConfirmClose>>,
        TError,
        {id: string;data: DreamControllerConfirmCloseBody},
        TContext
      > => {

      const mutationOptions = getDreamControllerConfirmCloseMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Replace dream images (owner only)
 */
export const dreamControllerAssignImages = (
    id: string,
    assignImagesDto: AssignImagesDto,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DreamDto>(
      {url: `/dreams/${id}/images`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: assignImagesDto
    },
      options);
    }
  


export const getDreamControllerAssignImagesMutationOptions = <TError = DreamControllerAssignImages401 | DreamControllerAssignImages429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerAssignImages>>, TError,{id: string;data: AssignImagesDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof dreamControllerAssignImages>>, TError,{id: string;data: AssignImagesDto}, TContext> => {

const mutationKey = ['dreamControllerAssignImages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dreamControllerAssignImages>>, {id: string;data: AssignImagesDto}> = (props) => {
          const {id,data} = props ?? {};

          return  dreamControllerAssignImages(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DreamControllerAssignImagesMutationResult = NonNullable<Awaited<ReturnType<typeof dreamControllerAssignImages>>>
    export type DreamControllerAssignImagesMutationBody = AssignImagesDto
    export type DreamControllerAssignImagesMutationError = DreamControllerAssignImages401 | DreamControllerAssignImages429

    /**
 * @summary Replace dream images (owner only)
 */
export const useDreamControllerAssignImages = <TError = DreamControllerAssignImages401 | DreamControllerAssignImages429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dreamControllerAssignImages>>, TError,{id: string;data: AssignImagesDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dreamControllerAssignImages>>,
        TError,
        {id: string;data: AssignImagesDto},
        TContext
      > => {

      const mutationOptions = getDreamControllerAssignImagesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns paginated transactions with cursor-based pagination.
 * @summary List transactions for a dream
 */
export const dreamControllerListTransactions = (
    id: string,
    params?: DreamControllerListTransactionsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DreamControllerListTransactions200>(
      {url: `/dreams/${id}/transactions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getDreamControllerListTransactionsQueryKey = (id?: string,
    params?: DreamControllerListTransactionsParams,) => {
    return [`/dreams/${id}/transactions`, ...(params ? [params]: [])] as const;
    }

    
export const getDreamControllerListTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError = DreamControllerListTransactions401 | DreamControllerListTransactions429>(id: string,
    params?: DreamControllerListTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDreamControllerListTransactionsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof dreamControllerListTransactions>>> = ({ signal }) => dreamControllerListTransactions(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DreamControllerListTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof dreamControllerListTransactions>>>
export type DreamControllerListTransactionsQueryError = DreamControllerListTransactions401 | DreamControllerListTransactions429


export function useDreamControllerListTransactions<TData = Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError = DreamControllerListTransactions401 | DreamControllerListTransactions429>(
 id: string,
    params: undefined |  DreamControllerListTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerListTransactions>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerListTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerListTransactions<TData = Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError = DreamControllerListTransactions401 | DreamControllerListTransactions429>(
 id: string,
    params?: DreamControllerListTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dreamControllerListTransactions>>,
          TError,
          Awaited<ReturnType<typeof dreamControllerListTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDreamControllerListTransactions<TData = Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError = DreamControllerListTransactions401 | DreamControllerListTransactions429>(
 id: string,
    params?: DreamControllerListTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List transactions for a dream
 */

export function useDreamControllerListTransactions<TData = Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError = DreamControllerListTransactions401 | DreamControllerListTransactions429>(
 id: string,
    params?: DreamControllerListTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dreamControllerListTransactions>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDreamControllerListTransactionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



